import { render, staticRenderFns } from "./Colophon.vue?vue&type=template&id=43805bc0&scoped=true&"
import script from "./Colophon.vue?vue&type=script&lang=js&"
export * from "./Colophon.vue?vue&type=script&lang=js&"
import style0 from "./Colophon.vue?vue&type=style&index=0&id=43805bc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43805bc0",
  null
  
)

export default component.exports